<ng-container [ngSwitch]="column.template || column.name">

    <span *ngSwitchCase="'proximitymeters'" class="text-nowrap">
        {{record[column.name]|number:'.4'}}
    </span>

    <div *ngSwitchCase="'correlationtime'" class="d-flex flex-row align-items-center text-nowrap ">
        <div>{{ record[column.name] | date: "yyyy-MM-dd HH:mm:ss.SSS":"UTC" }}</div>
        <div *ngIf="record['callGapSecs']" class="ml-1 flex-grow-1 text-right text-secondary small">
            {{record['callGapSecs']}}
        </div>
    </div>

    <div *ngSwitchCase="'volunteerid'">
        <a *ngIf="roleMgr.isAdmin||roleMgr.canAssignScheduler||roleMgr.canSchedule else noEdit" href="javascript:false"
            (click)="editVolunteer(record)">{{
            record[column.name]
            }}</a>
        <ng-template #noEdit>
            {{ record[column.name] }}
        </ng-template>
    </div>

    <ng-container *ngSwitchCase="'locationLink'">

        <a *ngIf="record['sourcetable']=='location_tmo_0'; else noLocationImpl" href="javascript:false;"
            (click)="showLocationTable($any(record))">
           {{record[column.name]}}
        </a>
        <ng-template #noLocationImpl>
           {{record[column.name]}}
        </ng-template>
    </ng-container>

    <a *ngSwitchCase="'callLink'" href="javascript:false;"
    (click)="showCallTable($any(record))">{{record[column.name]}}</a>

    <ng-container *ngSwitchCase="'correlationLink'">
        <a *ngIf="record[column.name]" href="javascript:false;" (click)="showCorrelation($any(record))"
            class="text-nowrap">
            {{record[column.name]|date:'yyyy-MM-dd HH:mm:ss.SSS':'UTC'}}
        </a>
    </ng-container>

    <ng-container *ngSwitchCase="'latlng'">
        {{record[column.name]|number:'1.2-6'}}
    </ng-container>


    <div *ngSwitchDefault fes-table-view-default-cell-renderer
      [column]="column"
      [record]="record"
      [tableComponent]="tableComponent"
    >  
    </div>

</ng-container>